
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"45","height":"45"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h45v45H0z","fill":"none"}}),_c('path',{attrs:{"d":"M35.625 35.625H9.375V9.375H22.5v-3.75H9.375a3.749 3.749 0 0 0-3.75 3.75v26.25a3.749 3.749 0 0 0 3.75 3.75h26.25a3.761 3.761 0 0 0 3.75-3.75V22.5h-3.75zm-9.375-30v3.75h6.731L14.55 27.806l2.644 2.644 18.431-18.431v6.731h3.75V5.625z"}})])
          )
        }
      }
    